import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Legal = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <PublicHeader />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="section-spacing bg-gradient-to-br from-primary/5 via-background to-secondary/10">
          <div className="container-custom text-center">
            <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl">
              Mentions légales
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
              Informations légales et politique de confidentialité
            </p>
          </div>
        </section>
        
        {/* Legal Content */}
        <section className="section-spacing">
          <div className="container-custom">
            <div className="mx-auto max-w-4xl space-y-8">
              {/* Mentions légales */}
              <Card>
                <CardHeader>
                  <CardTitle className="text-2xl">Mentions légales</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-muted-foreground">
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">Éditeur du site</h3>
                    <p>
                      Fruitycall SAS<br />
                      Société par actions simplifiée<br />
                      Capital social : 50 000 €<br />
                      RCS Paris 123 456 789<br />
                      Siège social : 123 Avenue de la Santé, 75014 Paris, France
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">Directeur de la publication</h3>
                    <p>Jean Dupont, Président</p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">Hébergement</h3>
                    <p>
                      OVH SAS<br />
                      2 rue Kellermann<br />
                      59100 Roubaix, France<br />
                      Téléphone : 1007
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">Contact</h3>
                    <p>
                      Email : contact@fruitycall.fr<br />
                      Téléphone : 01 23 45 67 89
                    </p>
                  </div>
                </CardContent>
              </Card>
              
              {/* Confidentialité */}
              <Card id="confidentiality">
                <CardHeader>
                  <CardTitle className="text-2xl">Politique de confidentialité</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-muted-foreground">
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">1. Collecte des données</h3>
                    <p>
                      Fruitycall collecte uniquement les données nécessaires au fonctionnement du service :
                      informations de compte (nom, email), messages vocaux et leurs transcriptions,
                      numéros de téléphone des appelants.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">2. Utilisation des données</h3>
                    <p>
                      Vos données sont utilisées exclusivement pour vous fournir le service de transcription
                      de messages vocaux. Nous ne vendons ni ne partageons vos données avec des tiers.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">3. Sécurité des données</h3>
                    <p>
                      Toutes les données sont chiffrées en transit et au repos. Nous utilisons des protocoles
                      de sécurité conformes aux normes HDS (Hébergeur de Données de Santé) et RGPD.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">4. Conservation des données</h3>
                    <p>
                      Les messages vocaux et transcriptions sont conservés pendant 90 jours par défaut.
                      Vous pouvez supprimer vos messages à tout moment depuis votre espace professionnel.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">5. Vos droits</h3>
                    <p>
                      Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression,
                      de limitation et de portabilité de vos données. Pour exercer ces droits, contactez-nous à
                      privacy@fruitycall.fr.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">6. Cookies</h3>
                    <p>
                      Nous utilisons uniquement des cookies essentiels au fonctionnement du service
                      (authentification, préférences). Aucun cookie de tracking ou publicitaire n'est utilisé.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">7. Modifications</h3>
                    <p>
                      Nous nous réservons le droit de modifier cette politique de confidentialité.
                      Toute modification sera communiquée par email aux utilisateurs.
                    </p>
                  </div>
                  
                  <div className="pt-4">
                    <p className="text-sm">
                      Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                  </div>
                </CardContent>
              </Card>
              
              {/* CGU */}
              <Card>
                <CardHeader>
                  <CardTitle className="text-2xl">Conditions générales d'utilisation</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-muted-foreground">
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">1. Objet</h3>
                    <p>
                      Les présentes conditions générales d'utilisation régissent l'accès et l'utilisation
                      de la plateforme Fruitycall par les professionnels de santé.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">2. Responsabilités</h3>
                    <p>
                      L'utilisateur s'engage à utiliser le service de manière conforme à la réglementation
                      en vigueur concernant les données de santé. Fruitycall ne peut être tenu responsable
                      du contenu des messages laissés par les appelants.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="mb-2 font-semibold text-foreground">3. Disponibilité du service</h3>
                    <p>
                      Nous nous efforçons d'assurer une disponibilité maximale du service. Des interruptions
                      peuvent survenir pour maintenance ou mises à jour, auquel cas les utilisateurs seront
                      prévenus dans la mesure du possible.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>
      
      <PublicFooter />
    </div>
  );
};

export default Legal;